<template>
  <div class="news">
    <PageHeading title="Aktuell" />
    <div class="news__filter">
      <Filter>
        <template #search>
          <input v-model="filter.search" type="search" placeholder="Suche">
        </template>
        <template #category>
          <select v-model="filter.category">
            <option v-for="category in filterData.categories.items" :key="category.id" :value="category.id">
              {{ category.name }}
            </option>
          </select>
        </template>
      </Filter>
    </div>
    <PageContent>
      <div v-if="!items.length" class="news__empty">
        {{ appConfig.noResults }}
      </div>
      <NewsCollection :items="items" />
    </PageContent>
    <div class="news__pager">
      <div class="news__pager-inner">
        <Pager
          :is-first-page
          :is-last-page
          :current-page
          :page-count
          @prev="prev"
          @next="next"
          @page-select="onPageSelect"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

const appConfig = useAppConfig()

const items = ref([])
const total = ref(0)
const pageSize = appConfig.defaultPageSize

const filter = ref({
  category: '',
  search: ''
})

const { data: filterData } = await useAsyncData('newsFilter', async () => {
  const data = await useGraphqlQuery('newsFilter').then((v) => {
    return v.data
  })
  data.categories?.items.unshift({
    id: '',
    name: 'Alle kategorien'
  })
  return data
})

const filterQuery = computed(() => {
  return {
    search: filter.value.search,
    category: [filter.value.category],
    searchEnabled: filter.value.search !== '',
    categoryEnabled: filter.value.category !== ''
  }
})

const { start, finish } = useLoadingIndicator()

const {
  currentPage,
  pageCount,
  isFirstPage,
  isLastPage,
  prev,
  next,
  offset,
  onPageSelect
} = await usePaginatedFilteredQuery(total, pageSize, fetchData, filterQuery)

async function fetchData (setData: Boolean = true) {
  start()
  return await useGraphqlQuery('news', {
    limit: pageSize,
    offset: offset.value,
    ...filterQuery.value
  }).then((v) => {
    // @todo: refactor this: move to usePaginatedFilteredQuery?
    if (setData) {
      items.value = v.data.posts.items
      total.value = v.data.posts.total
    }
    finish()
    return v.data.posts
  })
}

const { data } = await useAsyncData('news', async () => {
  return await fetchData(false)
})

items.value = data.value.items
total.value = data.value.total

useSeoMeta({
  title: 'Aktuell'
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.news {
  grid-column: 1 / span 6;

  &__pager {
    @include tools.grid;
  }

  &__pager-inner {
    @include tools.page-grid-columns-wide;
  }
}
</style>
